import { withTranslate } from "@pathwright/ui/src/components/"
import Button from "@pathwright/ui/src/components/button/Button"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"
import styled from "styled-components"
import FirstDiscussionQuery from "../../discussion/FirstDiscussionQuery"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { getInboxUrl } from "../../utils/urls"
import withCompletion from "../graphql/withCompletion"

const tPrefix = "completion.feedback.detail"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CompletionFeedbackDetailContainer = (props) => {
  const pwContext = usePathwrightContext()

  if (!props.step || !props.completion) {
    return null
  }

  const { t } = props

  const discussionContext = {
    completion_id: props.stepId,
    resource_id: props.step.context.resource_id,
    cohort_id: props.step.context.cohort_id
  }

  const feedbackDisabled = !props.step.completion.user

  return (
    <FirstDiscussionQuery context={discussionContext} type="feedback">
      {({ firstDiscussion: post, loading, refetch }) => {
        if (loading) {
          return null
        }

        // Don't allow a student to start feedback on a step that isn't set to manual review
        if (props.completion.grading_type !== "M" && !post) {
          return null
        }

        const to = getInboxUrl({
          cohortId: discussionContext.cohort_id,
          userId: pwContext.me.id,
          stepId: discussionContext.completion_id,
          selected: discussionContext.completion_id,
          panel: "discuss"
        })

        return (
          <Container>
            <Tooltip
              title={feedbackDisabled ? t(`${tPrefix}.disabled_message`) : ""}
            >
              <Text.Body>
                <Button
                  brand
                  disabled={feedbackDisabled}
                  styleType="blank"
                  to={to}
                  icon="chat-bubble"
                  label={
                    post || props.step.userpoints_explanation
                      ? t(`${tPrefix}.view`)
                      : t(`${tPrefix}.start`)
                  }
                  indicator={Boolean(post && !post.user_has_viewed_recent)}
                />
              </Text.Body>
            </Tooltip>
          </Container>
        )
      }}
    </FirstDiscussionQuery>
  )
}

CompletionFeedbackDetailContainer.displayName =
  "CompletionFeedbackDetailContainer"

CompletionFeedbackDetailContainer.propTypes = {
  stepId: PropTypes.number.isRequired
}

export default withCompletion(withTranslate(CompletionFeedbackDetailContainer))
